export default __webpack_public_path__ + "static/media/CLUBEZ_Login_logo.615ed094.png";